<template>
    <div id="consignment-queue-container">
        <card title="Consignment Queue">
            <b-table-simple fixed>
                <b-thead head-variant="dark">
                    <b-tr>
                        <b-th>Entered</b-th>
                        <b-th>Drug Name</b-th>
                        <b-th>Rx Number</b-th>
                        <b-th>Rf Number</b-th>
                        <b-th>Consignment Id</b-th>
                        <b-th>Save</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="consignment in consignments" :key="`${consignment.Id}`">
                        <b-td>{{ convertDate(consignment.entered) }}</b-td>
                        <b-td>{{ consignment.drugName }}</b-td>
                        <b-td>{{ consignment.rxNumber }}</b-td>
                        <b-td>{{ consignment.rfNumber }}</b-td>
                        <b-td>
                            <fg-input v-model="consignment.consignmentId" type="text" size="sm">
                            </fg-input>
                        </b-td>
                        <b-td>
                            <b-button size="sm" class="mb-2 mr-2" variant="success"
                                @click="updateConsignmentId(consignment)">Save</b-button>
                            <b-button size="sm" class="mb-2" variant="danger"
                                @click="cancelConsignmentId(consignment)">Cancel</b-button>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </card>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator';
import Axios, { AxiosResponse } from 'axios';
import moment from 'moment';
import { Consignment } from '@/models/Consignment'
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

@Component({
    name: "ConsignmentQueuePage",
    components: {
    },
})

export default class ConsignmentQueuePage extends Vue {

    private consignments: Array<Consignment> = [];

    created() {
        this.loadConsignments()
    }

    loadConsignments() {
        Axios.get(`/Consignment/GetIncomplete`)
            .then(response => {
                this.consignments = response.data
            })
            .catch(error => {
                console.warn(error);
                this.$notification(NotificationOptions.error(error));
            });
    }

    updateConsignmentId(consignment: Consignment) {
        let data = consignment
        console.log(data);
        Axios.post('/Consignment/UpdateConsignmentId', data)
            .then(() => {
                this.loadConsignments();
            })
            .catch(error => {
                console.warn(error);
                this.$notification(NotificationOptions.error(error));
            });
    }

    cancelConsignmentId(consignment: Consignment) {
        let data = consignment
        console.log(data);
        Axios.post('/Consignment/DeleteConsignmentId', data)
            .then(() => {
                this.loadConsignments();
            })
            .catch(error => {
                console.warn(error);
                this.$notification(NotificationOptions.error(error));
            });
    }

    convertDate(date: string) {
        return moment.utc(date).format("L");
    }
}

</script>
